import { Box } from '@mui/material'
import styled from 'styled-components'
import { FlexboxProps } from 'styled-system'
import { FlexBoxStyled } from 'utility/box'

// Full-viewport scroll area so the scrollbar sits at the window's right edge,
// like a regular page.
export const ImmersiveScreenScrollStyled = styled(Box)`
  height: 100vh;
  overflow-y: auto;
`

// Centers the card horizontally always, and vertically while it fits. Tall content
// grows this wrapper and scrolls from the top (the scroll area above is the outer
// element, so there is no flex-overflow top-clipping).
export const ImmersiveScreenContainerStyled = styled(FlexBoxStyled)<FlexboxProps>`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  padding: 40px 16px;
`

export const ImmersiveLogoStyled = styled(Box)<FlexboxProps>`
  padding-top: 20px;
  margin: auto;
  width: 60%;
`
